import { render, staticRenderFns } from "./listPromotion.vue?vue&type=template&id=08de01f9"
import script from "./listPromotion.vue?vue&type=script&lang=js"
export * from "./listPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports